module.exports = __webpack_public_path__ + "assets/img/27.22252032.png";